export function deepFreeze<T>(value: T): T {
  const seen = new WeakSet<object>();

  function freeze(v: unknown): void {
    if (
      typeof v !== "object" ||
      v === null ||
      Object.isFrozen(v) ||
      seen.has(v)
    ) {
      return;
    }

    seen.add(v);
    Object.freeze(v);

    for (const item of Object.values(v)) {
      freeze(item);
    }
  }

  freeze(value);
  return value;
}
